export let PRIVATE_GROUP_8 = [
	'mencu-group-1',
	'mencu-group-2',
	'mencu-group-3',
	'mencu-group-4',
	'mencu-group-5',
	'mencu-group-6',
	'mencu-group-7',
];

export const DZINTARS_PARTNERS = [
	"dzintars-partner-1",
	"dzintars-partner-2",
	"dzintars-partner-3",
	"dzintars-partner-4",
	"dzintars-partner-5",
	"dzintars-partner-6",
	"dzintars-partner-7",
	"dzintars-partner-8",
	"dzintars-partner-9",
	"dzintars-partner-10",
	"dzintars-partner-11",
	"dzintars-partner-12",
	"dzintars-partner-13",
	"dzintars-partner-14",
	"dzintars-partner-15",
	"dzintars-partner-16",
]

export const LNB_PARTNERS = [
	"lnb-partner-1",
	"lnb-partner-2",
	"lnb-partner-3",
	"lnb-partner-4",
	"lnb-partner-5",
	"lnb-partner-6",
]

export const LNB_INFRASTRUCTURE_PARTNERS_1 = [
	"lnb-infra-partner-1",
	"lnb-infra-partner-2",
	"lnb-infra-partner-3",
	"lnb-infra-partner-4",
	"lnb-infra-partner-5",
]

export const LNB_INFRASTRUCTURE_PARTNERS_2 = [
	"lnb-infra-partner-2-1",
	"lnb-infra-partner-2-2",
	"lnb-infra-partner-2-3",
	"lnb-infra-partner-2-4",
	"lnb-infra-partner-2-5",
	"lnb-infra-partner-2-6",
]

export const VENTSPILS_PARTNERS = [
	"ventspils-partner-1",
	"ventspils-partner-2",
	"ventspils-partner-3",
	"ventspils-partner-4",
	"ventspils-partner-5",
	"ventspils-partner-6",
	"ventspils-partner-7",
	"ventspils-partner-8",
	"ventspils-partner-9",
	"ventspils-partner-10",
	"ventspils-partner-11",
	"ventspils-partner-12",
	"ventspils-partner-13",
	"ventspils-partner-14",
]

export const Z_TOWERS_PARTNERS = [
	"z-towers-partner-1",
	"z-towers-partner-2",
	"z-towers-partner-3",
	"z-towers-partner-4",
	"z-towers-partner-5",
	"z-towers-partner-6",
]

export const PRIVATE_PARTNER_1 = [
	"private-1-group-1",
	"private-1-group-2",
	"private-1-group-3",
	"private-1-group-4",
	"private-1-group-5",
	"private-1-group-6",
	"private-1-group-7",
	"private-1-group-8",
]


export const PRIVATE_PARTNER_2 = [
	"private-2-group-1",
	"private-2-group-2",
	"private-2-group-3",
	"private-2-group-4",
	"private-2-group-5",
	"private-2-group-6",
	"private-2-group-7",
]


export const PRIVATE_PARTNER_3 = [
	"private-3-group-1",
	"private-3-group-2",
	"private-3-group-3",
	"private-3-group-4",
	"private-3-group-5",
	"private-3-group-6",
	"private-3-group-7",
]

export const PRIVATE_PARTNER_4 = [
	"private-4-group-1",
	"private-4-group-2",
]

export const PRIVATE_GROUP_1 = [
	"private-lattelecom-group-1",
	"private-lattelecom-group-2",
	"private-lattelecom-group-3",
	"private-lattelecom-group-4",
]

export const PRIVATE_GROUP_2 = [
	"angel-group-1",
	"angel-group-2",
	"angel-group-3",
]

export const PRIVATE_GROUP_3 = [
	"diklu-group-1",
	"diklu-group-2",
	"diklu-group-3",
]

export const PRIVATE_GROUP_4 = [
	"langstini–group-1",
	"langstini–group-2",
	"langstini–group-3",
]

export const PRIVATE_GROUP_5 = [
	"mildas15–group-1",
	"mildas15–group-2",
	"mildas15-group-3",
]

export const PRIVATE_GROUP_6 = [
	"konkordijas-group-1",
	"konkordijas-group-2",
	"konkordijas-group-3",
]

export const PRIVATE_GROUP_7 = [
	'saules-group-1',
	'saules-group-2',
	'saules-group-3',
	'saules-group-4',
	'saules-group-5',
	'saules-group-6',
	'saules-group-7',
]

export const TV_TOWER_PARTNERS = [
	"tv-tower-partner-1",
	"tv-tower-partner-2",
	"tv-tower-partner-3",
	"tv-tower-partner-4",
	"tv-tower-partner-5",
	"tv-tower-partner-6",
	"tv-tower-partner-7",
	"tv-tower-partner-8",
	"tv-tower-partner-9",
	"tv-tower-partner-10",
	"tv-tower-partner-11",
]

export const TV3_PARTNERS = [
	"tv3-group-1",
	"tv3-group-2",
	"tv3-group-3",
	"tv3-group-4",
	"tv3-group-5",
	"tv3-group-6",
	"tv3-group-7",
	"tv3-group-8",
]

export const PROPOSALS_GROUP_1 = [
	"estrade-group-1",
	"estrade-group-2",
	"estrade-group-3",
	"estrade-group-4",
	"estrade-group-5",
]

export default [
	DZINTARS_PARTNERS,
	LNB_PARTNERS,
	LNB_INFRASTRUCTURE_PARTNERS_1,
	LNB_INFRASTRUCTURE_PARTNERS_2,
	VENTSPILS_PARTNERS,
	Z_TOWERS_PARTNERS,
	PRIVATE_PARTNER_1,
	PRIVATE_PARTNER_2,
	PRIVATE_PARTNER_3,
	PRIVATE_GROUP_4,
	PRIVATE_GROUP_5,
	PRIVATE_GROUP_6,
	PRIVATE_GROUP_7,
	TV_TOWER_PARTNERS,
	TV3_PARTNERS,
	PROPOSALS_GROUP_1
]